import { useCallback, useState } from "react";
import { IApiPagination } from "../../../../interfaces/IPagination";

export type UsePaginationOptions = {
  initialPageSize?: number;
  initialSortBy?: string;
  initialSortOrder?: "asc" | "desc";
};

export const usePagination = (options?: UsePaginationOptions) => {
  const { initialPageSize = 20, initialSortBy, initialSortOrder } =
    options || {};

  const [pagination, setPagination] = useState<IApiPagination>({
    page: 1,
    pageSize: initialPageSize,
    sortBy: initialSortBy,
    sortOrder: initialSortOrder,
  });

  const handlePageChange = (page: number) => {
    setPagination((prev) => ({
      ...prev,
      page,
    }));
  };

  const handlePageSizeChange = (pageSize: number) => {
    setPagination((prev) => ({
      ...prev,
      page: 1,
      pageSize,
    }));
  };

  const handleSort = useCallback((key: string) => {
    setPagination((prev) => ({
      ...prev,
      page: 1,
      sortBy: key,
      sortOrder:
        prev.sortBy === key && prev.sortOrder === "desc" ? "asc" : "desc",
    }));
  }, []);

  return {
    pagination,
    handlePageChange,
    handlePageSizeChange,
    handleSort,
  };
};
